module.exports = __webpack_public_path__ + "img/BH.57c40254.png";